import React from 'react';
import { translate } from 'react-i18next';
import { Form } from 'common/components';

import { createRoute } from 'lib/util';

const CatalogActionsEdit = ({ catalog, company, subcompany, t, handleClick = () => {} }) => (
  <Form.Link
    className={'btn btn-outline-primary btn-sm mx-1'}
    to={createRoute(company.id, subcompany.id, `catalogs/${catalog.id}/edit`)}
  >
    {t('actions.edit')}
  </Form.Link>
);

export default translate()(CatalogActionsEdit);



// WEBPACK FOOTER //
// src/modules/secured/modules/catalogs/components/list/actions/CatalogsActionsEdit.js